import { Injectable } from '@angular/core';
import { EMPTY, map, Observable, Observer } from 'rxjs';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { ConfirmComponent } from './confirm/confirm.component';

interface ConfirmParams {
  title?: string,
  height?: string,
  showCancelButton?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  private confirmComp: ConfirmComponent | null = null;

  constructor() { }

  initService(confirm: ConfirmComponent) {
    this.confirmComp = confirm;
  }

  confirm(content: string = 'Deseja realmente realizar essa operação?', params: ConfirmParams = {
    title: 'Atenção!'
  }): Observable<boolean> {
    if(!this.confirmComp)
      throw `this.confirmComp is null.`;

    this.confirmComp.showCancelButton(params?.showCancelButton ?? true);

    return this.confirmComp.show(params.title ?? 'Atenção', content);
  }

  inform(content: string = 'Operação realizada com sucesso!', params: ConfirmParams = {
    title: 'Atenção!'
  }): Observable<boolean> {
    if(!this.confirmComp)
      throw `this.confirmComp is null.`;

    this.confirmComp.showCancelButton(false);

    return this.confirmComp.show(params.title ?? 'Atenção', content);
  }

}
